import _URL from "../../URL/index";
const axios = _URL.axios;
export default {
  services: {
    getDocuments: (limit, page, query = "", token = "") => {
      return axios(token).get(
        `/documents?limit=${limit}&page=${page}${query ? `&${query}` : ""}`
      );
    },

    getDocumentById: (documentId, token = "") => {
      return axios(token).get(`/documents/${documentId}`);
    },

    getLastReleaseByApp: (app, token = "") => {
      return axios(token).get(`/latest-version/${app}`);
    },
    getReleasesByApp: (app, token = "") => {
      return axios(token).get(`/releases/${app}`);
    },
    getCurrentReleaseByApp: (app, token = "") => {
      return axios(token).get(`/current-version/${app}`);
    },
    markReleaseAsWatched: (app, releaseVersion, payload, token = "") => {
      return axios(token).put(
        `/apps/${app}/releases/${releaseVersion}/mark-as-read`,
        payload
      );
    },
    checkViewedRelease: (app, releaseVersion, userId, token = "") => {
      return axios(token).get(
        `/apps/${app}/releases/${releaseVersion}/users/${userId}/check-viewed-release`
      );
    },
    getDocuemetsOptions: (app, search, token = "") => {
      return axios(token).get(
        `/search-docuemets-options?app=${app}&search=${search}`
      );
    },
    getDocumentsBySearchCriteria: (searchCriteria, token = "") => {
      return axios(token).post(`/documents-search`, searchCriteria);
    },
    getDocumentDetails: (app, documentSlug, token = "") => {
      return axios(token).get(`/document-details/${app}/${documentSlug}`);
    },
    getArticles: (query = "", limit, page, token = "") => {
      return axios(token).get(
        `/articles?limit=${limit}&page=${page}${query ? `&${query}` : ""}`
      );
    },
    getSupportDocuments: (app, module, token = "") => {
      return axios(token).get(`/apps/${app}/modules/${module}/help`);
    }
  }
};
